// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HSdj","top":"styles_top__2M8wE"};